module.exports = __webpack_public_path__ + "img/Recycler1.dcdc62f4.png";